import { CoverageByHourFragment } from 'generated/resources/graphql'
import type moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'

export interface Props {
  date: moment.Moment
  numberOfShifts: number
}

class Coverage {
  date: moment.Moment
  numberOfShifts: number

  constructor(props: Props) {
    this.date = props.date.clone()
    this.numberOfShifts = props.numberOfShifts
  }

  static buildFromRequest(fragment: CoverageByHourFragment): Coverage {
    return new Coverage({
      date: stringToDate(fragment.date, 'backend_datetime'),
      numberOfShifts: fragment.numberOfShifts,
    })
  }
}

export default Coverage
